export function calculaValorCorteMadeira(
    valorTotal: number | undefined,
    metroCubicoTotal: number | undefined,
    metroCubicoCortado: number): number {
    // Verifica se os valores são válidos para evitar divisões por zero
    if (metroCubicoTotal === 0 || valorTotal === undefined || metroCubicoTotal === undefined) {
        throw new Error("Um ou mais valores invalidos!");
    }

    // Calcula o valor proporcional do corte
    const valorCorte = (metroCubicoCortado / metroCubicoTotal) * valorTotal;
    return valorCorte;
}

// Função para calcular depreciação da máquina com horas trabalhadas convertidas para dias
const HORAS_POR_DIA = 8; // Define uma constante para horas por dia
const DIAS_NO_ANO = 365; // Define o número de dias em um ano
export const calcularGastoDepreciacao = (valorAquisicao: number, vidaUtil: number, horasTrabalhadas: number): number => {
    // Validação de entradas
    if (valorAquisicao <= 0 || vidaUtil <= 0 || horasTrabalhadas < 0) {
        throw new Error("Valores de entrada devem ser positivos.");
    }

    const diasTrabalhados = horasTrabalhadas / HORAS_POR_DIA; // Converte as horas em dias
    const depreciacaoDiaria = valorAquisicao / (vidaUtil * DIAS_NO_ANO); // Cálculo da depreciação diária
    const gastoDepreciacao = depreciacaoDiaria * diasTrabalhados; // Cálculo do gasto com depreciação
    return gastoDepreciacao; // Retorna o valor numérico
};


// Função para calcular gasto com energia
export const calcularGastoEnergia = (
    horasTrabalhadasEnergia: number,
    custoCombustivel: number = 5,  // Valor padrão para combustíveis
    consumoPorHora: number = 2     // Consumo por hora do motor (diesel/gasolina)
): string => {

    const gastoCombustivel = consumoPorHora * horasTrabalhadasEnergia * custoCombustivel;
    return gastoCombustivel.toFixed(2);

};

// Função para calcular gasto com mão de obra
export const calcularGastoMaoDeObra = (horasTrabalhadasFuncionario: number, custoHoraTrabalhada: number): string => {
    const gastoMaoDeObra = horasTrabalhadasFuncionario * custoHoraTrabalhada;
    return gastoMaoDeObra.toFixed(2);
};
